// Complete LaserTags Silicone Tag Inventory
// Two-step selection: Shape → Color
// Photos served from backendlaser at /materials/

import { materialImageUrl } from '../utils/materialCatalog';
import { buildStaticInventoryFromBackend } from './backendMaterialCatalog';

export const SHAPES = [
  {
    id: 'bone',
    name: 'Bone',
    displayName: 'Classic Bone',
    icon: '🦴',
    description: 'Traditional pet tag shape',
    popularityRank: 1,
  },
  {
    id: 'rect',
    name: 'Rectangle',
    displayName: 'Rectangle',
    icon: '▭',
    description: 'Maximum engraving space',
    popularityRank: 2,
    badge: 'Most Space',
  },
  {
    id: 'circ',
    name: 'Circle',
    displayName: 'Circle',
    icon: '●',
    description: 'Sleek and modern',
    popularityRank: 3,
  },
  {
    id: 'hex',
    name: 'Hexagon',
    displayName: 'Hexagon',
    icon: '⬡',
    description: 'Modern geometric style',
    popularityRank: 5,
  },
];

export const INVENTORY = buildStaticInventoryFromBackend();

export function resolveVariantImage(variant) {
  if (!variant) return null;
  if (variant.imagePath) return materialImageUrl(variant.imagePath);
  return variant.image ?? null;
}

export const getVariantsByShape = (shapeId) => INVENTORY[shapeId] || [];

export const getAvailableVariantsByShape = (shapeId) =>
  getVariantsByShape(shapeId).filter((variant) => variant.stock);

export const getVariantById = (variantId) => {
  for (const shapeId in INVENTORY) {
    const variant = INVENTORY[shapeId].find((v) => v.id === variantId);
    if (variant) {
      return {
        ...variant,
        image: resolveVariantImage(variant),
        shape: SHAPES.find((s) => s.id === shapeId),
      };
    }
  }
  return null;
};

export const getShapeById = (shapeId) => SHAPES.find((s) => s.id === shapeId);

export const getTotalInventoryCount = () =>
  Object.values(INVENTORY).reduce((total, variants) => total + variants.length, 0);

export const getInStockCount = () =>
  Object.values(INVENTORY).reduce(
    (total, variants) => total + variants.filter((v) => v.stock).length,
    0,
  );

export const INVENTORY_STATS = {
  totalVariants: getTotalInventoryCount(),
  inStock: getInStockCount(),
  outOfStock: getTotalInventoryCount() - getInStockCount(),
  shapes: SHAPES.length,
};
